<template>
  <q-page padding>
    <div
      style="align-items: center"
      class="row col-12 justify-between align-center"
    >
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Consulta Status
        <q-icon
          style="cursor: pointer"
          name="info_outlined"
          @click="activeSlide = !activeSlide"
        />
      </p>
      <span
        style="cursor: pointer"
        class="row justify-end q-mt-md q-mb-md"
        @click="backPage"
      >
        <div @click="backPage" class="row align-center">
          <q-icon
            label="voltar"
            class="q-mr-sm"
            color="grey"
            size="sm"
            name="west"
          />
          <span style="color: #8a8a8a; font-size: 20px">Voltar</span>
        </div>
      </span>
    </div>

    <div class="cards-topo">
      <section style="background-color: #00c0ef">
        <div class="topo-numero">{{ dadosTopo.primeiro }}</div>
        <div class="topo-sub">Associado Produtos x Pessoas</div>
      </section>
      <section style="background-color: #58c16d">
        <div class="topo-numero">{{ dadosTopo.segundo }}</div>
        <div class="topo-sub">Dentro do Prazo</div>
      </section>
      <section style="background-color: #f39c12">
        <div class="topo-numero">{{ dadosTopo.terceiro }}</div>
        <div class="topo-sub">Associações Sem Movimento</div>
      </section>
      <section style="background-color: #dd4b39">
        <div class="topo-numero">{{ dadosTopo.quarto }}</div>
        <div class="topo-sub">Prazo Máximo Excedido</div>
      </section>
    </div>

    <div class="filtros-row q-mb-md">
      <div class="filtro-col">
        <div class="texto-titulo-input">Unidade:</div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade.nome"
        ></lista-unidades-select>
      </div>
      <div class="filtro-col">
        <div class="texto-titulo-input">Colaborador:</div>
        <SelecaoSolicitante
          class="input-new-design"
          :vendorId="unidade.id"
          @emitirFuncionario="receberFuncionario"
        />
      </div>
    </div>

    <div v-if="userData.nome" class="filtros-row">
      <div class="filtro-col">
        <div class="texto-titulo-input">Status:</div>
        <q-select
          label="Selecione o status"
          :options="tipos"
          v-model="status"
          dense
          outlined
        />
      </div>

      <div class="filtro-col">
        <div class="texto-titulo-input">Grupo Produto:</div>
        <q-select
          dense
          outlined
          v-model="grupoSelecionado"
          :options="grupoOptions"
          use-input
          clearable
          multiple
          input-debounce="300"
          :loading="loadingGrupo"
          @filter="filtrarGrupo"
          label="Selecione o grupo"
          :display-value="
            grupoSelecionado && grupoSelecionado.length > 0
              ? grupoSelecionado[0].name +
                (grupoSelecionado.length > 1 ? ' ...' : '')
              : ''
          "
        >
          <q-tooltip
            v-if="grupoSelecionado && grupoSelecionado.length > 1"
            anchor="top middle"
            self="bottom middle"
            class="bg-grey-8"
          >
            <div v-for="g in grupoSelecionado" :key="g.id">{{ g.name }}</div>
          </q-tooltip>
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"
                >Nenhum resultado</q-item-section
              >
            </q-item>
          </template>
          <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.name }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div class="filtro-col">
        <div class="texto-titulo-input">Regra Crítica:</div>
        <q-select
          label="Selecione a regra crítica"
          :options="regraOptions"
          v-model="regraCritica"
          dense
          outlined
        />
      </div>
    </div>

    <section v-if="userData.nome" class="list-container">
      <div v-for="(grupo, index) in rows" :key="index" class="grupo-container">
        <div class="card-img-wrap">
          <q-img
            spinner-color="white"
            height="72px"
            width="72px"
            src="../../../assets/imageDefoult.jpg"
            fit="contain"
            no-native-menu
            class="card-img"
          />
        </div>

        <div class="card-body">
          <span class="card-label">GRUPO PRODUTO</span>
          <span class="card-name">{{ grupo.grupo_nome }}</span>
          <span
            class="card-status-badge"
            :style="{
              color: getTitleColor(grupo?.Status),
              backgroundColor: getBadgeBg(grupo?.Status),
            }"
          >
            {{ grupo?.Status?.toUpperCase() }}
          </span>
        </div>

        <div class="card-footer">
          <div class="card-footer-left">
            <span class="card-label">
              <template
                v-if="grupo.Status == 'ATENÇÃO' || grupo.Status == 'ATRASADO'"
                >RETIRADA MÁXIMA</template
              >
              <template v-else>PRÓXIMA RETIRADA</template>
            </span>
            <span
              class="card-retirada-badge"
              :style="{
                color: getTitleColor(grupo?.Status),
                backgroundColor: getBadgeBg(grupo?.Status),
              }"
            >
              <template v-if="grupo?.prazo_maximo">
                {{
                  grupo.prazo_maximo
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </template>
              <template v-else>Sem prazo</template>
            </span>
            <span
              v-if="grupo['Dias para vencer máximo']"
              class="card-dias"
              :style="{ color: getTitleColor(grupo?.Status) }"
            >
              <template v-if="Math.sign(grupo['Dias para vencer máximo']) == 1">
                Vence em {{ grupo["Dias para vencer máximo"] }} dias
              </template>
              <template
                v-else-if="Math.sign(grupo['Dias para vencer máximo']) == -1"
              >
                Vencido há {{ Math.abs(grupo["Dias para vencer máximo"]) }} dias
              </template>
            </span>
          </div>
          <div class="card-footer-right">
            <span class="card-label">REGRA CRÍTICA</span>
            <span
              class="card-critico-badge"
              :class="
                grupo.critico == 1 ? 'card-critico-sim' : 'card-critico-nao'
              "
            >
              {{ grupo.critico == 1 ? "SIM" : "NÃO" }}
            </span>
          </div>
        </div>
      </div>
    </section>

    <div v-if="rows.length > 0" class="row justify-start q-mt-md">
      <q-pagination
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="true"
        :direction-links="true"
        size="sm"
      />
    </div>
    <SlideInformations :infos="infos" :activeSlide="activeSlide" />
  </q-page>
</template>

<script>
import { useRouter } from "vue-router";
import { onMounted, watch, ref, computed } from "vue";
import { useQuasar } from "quasar";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
import SlideInformations from "../components/SlideInformations.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { useStore } from "vuex";
export default {
  components: {
    ListaUnidadesSelect,
    SlideInformations,
    SelecaoSolicitante,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();
    const activeSlide = ref(false);
    const dadosTopo = ref({
      primeiro: 0,
      segundo: 0,
      terceiro: 0,
      quarto: 0,
    });
    const rows = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });
    const userData = ref({
      nome: "",
      ghe: "",
      matricula: "",
      id: "",
      unidade: "",
      centro: "",
      cargo: "",
    });
    const time = ref(null);
    const status = ref("");
    const grupoSelecionado = ref([]);
    const grupoOptions = ref([]);
    const loadingGrupo = ref(false);
    const regraCritica = ref(null);
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });

    const unidadeList = ref([]);

    const getDados = async () => {
      quasar.loading.show();

      if (userData.value.id == "") {
        quasar.loading.hide();
        return;
      }
      // if (
      //   store.state.autenticacao.cliente.includes("staging-vale") ||
      //   store.state.autenticacao.cliente.includes("vale-epiexpress")
      // ) {
      //   return;
      // }
      try {
        let response = await store.dispatch("ind/getStatusTroca", {
          vendor_id: unidade.value.id,
          per_page: 12,
          page: pagination.value.page,
          product_group_ids:
            grupoSelecionado.value && grupoSelecionado.value.length > 0
              ? grupoSelecionado.value.map((g) => g.id).join(",")
              : undefined,
          status: status.value.value,
          user_id: userData.value.id,
          regra_critica: regraCritica.value?.value,
        });
        if (response.data.result.data.length == 0) {
          quasar.loading.hide();
          quasar.notify({
            message:
              "Usuário selecionado não possui regras na unidade selecionada",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        rows.value = response.data.result.data;
        const currentPage =
          response.data.result.page ??
          response.data.result.current_page ??
          pagination.value.page;
        const perPage =
          response.data.result.per_page ?? pagination.value.rowsPerPage;
        const hasMore = response.data.result.data.length >= perPage;
        pagination.value.rowsPerPage = perPage;
        pagination.value.page = currentPage;
        pagination.value.rowsNumber = hasMore
          ? currentPage * perPage + perPage
          : currentPage * perPage;
        quasar.loading.hide();
        getDadosTopo();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message:
            "Usuário selecionado não possui regras na unidade selecionada",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getDadosTopo = async () => {
      // if (
      //   store.state.autenticacao.cliente.includes("staging-vale") ||
      //   store.state.autenticacao.cliente.includes("vale-epiexpress")
      // ) {
      //   return;
      // }
      try {
        let response = await store.dispatch("ind/getStatusTrocaTopo", {
          vendor_id: unidade.value.id,
          pessoa: userData.value.nome,
        });

        dadosTopo.value.primeiro = response.data.quantidade_de_associacoes;
        dadosTopo.value.segundo = response.data.numero_itens_dentro_prazo;
        dadosTopo.value.terceiro = response.data.associacoes_sem_nunca_ter_pego;
        dadosTopo.value.quarto = response.data.numero_itens_fora_prazo;
        quasar.loading.hide();
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const backPage = async () => {
      router.push({ name: "spf-inicial" });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
      }
    );

    const receberFuncionario = (value) => {
      userData.value.nome = value?.name;
      userData.value.ghe = value?.function;
      userData.value.centro = value?.cost_center?.name;
      userData.value.cargo = value?.roles[0]?.name;
      userData.value.matricula = value?.sap;
      userData.value.id = value?.id;
      unidadeList.value = value?.vendors;
    };

    const getUnidade = () => {
      quasar.loading.show();
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
        getDados();
      } else {
        quasar.loading.hide();
      }
    };

    onMounted(getUnidade);

    const getTitleColor = (tipo) => {
      switch (tipo) {
        case "Nunca retirou":
          return "#8A8A8A";

        case "ATRASADO":
          return "#dd2153";

        case "OK":
          return "#85D546";

        case "ATENÇÃO":
          return "#D19600";

        default:
      }
    };

    const getBadgeBg = (tipo) => {
      switch (tipo) {
        case "Nunca retirou":
          return "#f0f0f0";
        case "ATRASADO":
          return "#fde8ee";
        case "OK":
          return "#eaf9de";
        case "ATENÇÃO":
          return "#fdf6e3";
        default:
          return "#f0f0f0";
      }
    };

    const filtrarGrupo = async (val, update) => {
      loadingGrupo.value = true;
      try {
        const response = await store.dispatch(
          "simplificadoStore/listarGrupoProdutos",
          {
            unidade: unidade.value.id,
            search: val,
            per_page: 20,
          }
        );
        grupoOptions.value = response.data.results.data || [];
      } catch (error) {
        grupoOptions.value = [];
      } finally {
        loadingGrupo.value = false;
        update();
      }
    };

    watch(
      () => grupoSelecionado.value,
      () => {
        getDados();
      }
    );

    watch(
      () => regraCritica.value,
      () => {
        getDados();
      }
    );

    watch(
      () => status.value,
      () => {
        getDados();
      }
    );

    watch(
      () => userData.value.id,
      () => {
        getDados();
      }
    );

    watch(
      () => unidade.value.id,
      () => {
        getDados();
      }
    );
    watch(
      () => pagination.value.page,
      () => {
        getDados();
      }
    );

    return {
      backPage,
      unidade,
      receberFuncionario,
      userData,
      unidadeList,
      dadosTopo,
      rows,
      time,
      getTitleColor,
      getBadgeBg,
      status,
      grupoSelecionado,
      grupoOptions,
      loadingGrupo,
      filtrarGrupo,
      getDadosTopo,
      pagination,
      activeSlide,
      regraCritica,
      regraOptions: [
        { label: "Todos", value: undefined },
        { label: "Sim", value: "critica" },
        { label: "Não", value: "nao_critica" },
      ],
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      tipos: [
        { label: "Todos", value: "" },
        { label: "Dentro do Prazo", value: "bloqueado" },
        { label: "Pode Trocar", value: "liberado" },
        { label: "Deve Trocar", value: "atrasado" },
      ],
      infos: [
        {
          text: "Item nunca retirado pelo usuário.",
          type: "Nunca Retirou",
        },
        {
          text: "Item não atingiu o prazo mínimo da próxima retirada.",
          type: "Ok",
        },
        {
          text: "Item atingiu o prazo mínimo para a retirada, indicando os dias restantes para vencer.",
          type: "Atenção",
        },
        {
          text: "Item excedeu o prazo máximo para a retirada, indicando os dias vencidos.",
          type: "Atrasado",
        },
      ],
    };
  },
};
</script>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}
</style>

<style scoped>
.cards-topo {
  display: flex;
  margin-bottom: 24px;
  gap: 12px;
  margin-top: 0;
}
.cards-topo section {
  flex: 1;
  height: 129px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 7px;
}
.topo-numero {
  font-size: 42px;
  color: #fff;
  line-height: 1.1;
}
.topo-sub {
  margin-top: 10px;
  font-size: 16px;
  text-align: center;
  padding: 14px;
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
}

.grupo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 12px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  text-align: center;
  gap: 6px;
}

.card-img-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
}

.card-img {
  border-radius: 50%;
  overflow: hidden;
}

.card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.card-label {
  font-size: 10px;
  font-weight: 600;
  color: #8a8a8a;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-status-badge {
  display: inline-block;
  padding: 2px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.card-name {
  font-size: 14px;
  font-weight: 700;
  color: #21324a;
  line-height: 1.3;
}

.card-footer {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 30px;
  width: 100%;

  padding-top: 8px;
  margin-top: 4px;
}

.card-footer-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.card-footer-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.card-critico-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.card-critico-sim {
  color: #dd2153;
  background-color: #fde8ee;
}

.card-critico-nao {
  color: #8a8a8a;
  background-color: #f0f0f0;
}

.card-retirada-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.card-dias {
  font-size: 10px;
  font-weight: 600;
}

.filtros-row {
  display: flex;
  gap: 16px;
  margin-top: 12px;
}

.filtro-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

@media (max-width: 600px) {
  .filtros-row {
    flex-direction: column;
  }
  .cards-topo {
    flex-wrap: wrap;
  }
  .cards-topo section {
    flex: 1 1 calc(50% - 6px);
  }
}

.info-user {
  padding: 12px;
  height: 150px;
  max-width: 890px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  margin-top: 26px;
}

.texto-titulo-input {
  font-size: 12px;
}

.list-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 30px;
}

@media (max-width: 900px) {
  .list-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .list-container {
    grid-template-columns: 1fr;
  }
}

.align-center {
  align-items: center;
}
</style>
